import type { LocaleMessageBundle } from '../../types'

export const productUnitMessages: LocaleMessageBundle = {
  vi: {
    'product.unit.model': 'Đơn vị tính',
    'product.unit.title': 'Đơn vị tính',
    'product.unit.fields.code': 'Mã đơn vị',
    'product.unit.fields.name': 'Tên đơn vị',
    'product.unit.fields.type': 'Loại đơn vị',
    'product.unit.fields.status': 'Trạng thái',
    'product.unit.fields.sortOrder': 'Thứ tự',
    'product.unit.status.active': 'Đang dùng',
    'product.unit.status.inactive': 'Tạm ngưng',
    'product.unit.types.quantity': 'Số lượng',
    'product.unit.types.time': 'Thời gian',
    'product.unit.types.package': 'Gói',
    'product.unit.types.other': 'Khác',
    'product.unit.actions.add': 'Thêm đơn vị',
    'product.unit.actions.create': 'Thêm đơn vị tính',
    'product.unit.actions.update': 'Cập nhật đơn vị tính',
    'product.unit.actions.submitCreate': 'Tạo mới',
    'product.unit.actions.submitUpdate': 'Cập nhật',
    'product.unit.actions.cancel': 'Đóng',
    'product.unit.actions.delete': 'Xóa',
    'product.unit.actions.deleteTitle': 'Xóa đơn vị tính',
    'product.unit.dialog.createSubtitle': 'Tạo đơn vị tính mới để quản lý sản phẩm tốt hơn',
    'product.unit.dialog.updateSubtitle': 'Cập nhật thông tin đơn vị tính trong hệ thống',
    'product.unit.placeholders.code': 'Nhập mã đơn vị',
    'product.unit.placeholders.name': 'Nhập tên đơn vị',
    'product.unit.help.code':
      'Mã đơn vị dùng để định danh duy nhất trong hệ thống. Ví dụ: cai, hop, thung...',
    'product.unit.help.type': 'Chọn loại đơn vị phù hợp với cách quy đổi và sử dụng',
    'product.unit.help.status': 'Chỉ những đơn vị đang dùng mới được hiển thị khi chọn sản phẩm',
    'product.unit.help.sortOrder': 'Số thứ tự hiển thị từ 0 đến 100. Số nhỏ sẽ hiển thị trước',
    'product.unit.validation.sortOrderRange': 'Thứ tự phải từ 0 đến 100',
    'product.unit.preview.title': 'Xem trước',
    'product.unit.preview.description':
      'Đơn vị tính này sẽ hiển thị trong danh sách sản phẩm theo thứ tự bạn đã thiết lập.',
    'product.unit.deleteConfirm': 'Bạn có chắc muốn xóa đơn vị {name}?',
    'product.unit.errors.saveFailed': 'Không thể lưu đơn vị tính. Vui lòng thử lại.',
  },
  en: {
    'product.unit.model': 'Unit',
    'product.unit.title': 'Units',
    'product.unit.fields.code': 'Unit code',
    'product.unit.fields.name': 'Unit name',
    'product.unit.fields.type': 'Unit type',
    'product.unit.fields.status': 'Status',
    'product.unit.fields.sortOrder': 'Sort order',
    'product.unit.status.active': 'Active',
    'product.unit.status.inactive': 'Inactive',
    'product.unit.types.quantity': 'Quantity',
    'product.unit.types.time': 'Time',
    'product.unit.types.package': 'Package',
    'product.unit.types.other': 'Other',
    'product.unit.actions.add': 'Add unit',
    'product.unit.actions.create': 'Create unit',
    'product.unit.actions.update': 'Update unit',
    'product.unit.actions.submitCreate': 'Create',
    'product.unit.actions.submitUpdate': 'Update',
    'product.unit.actions.cancel': 'Cancel',
    'product.unit.actions.delete': 'Delete',
    'product.unit.actions.deleteTitle': 'Delete unit',
    'product.unit.dialog.createSubtitle': 'Create a new unit to manage products more effectively',
    'product.unit.dialog.updateSubtitle': 'Update unit information in the system',
    'product.unit.placeholders.code': 'Enter unit code',
    'product.unit.placeholders.name': 'Enter unit name',
    'product.unit.help.code':
      'Unit code uniquely identifies the unit in the system. Example: piece, box, carton...',
    'product.unit.help.type': 'Choose the unit type that matches conversion and usage',
    'product.unit.help.status': 'Only active units are shown when selecting products',
    'product.unit.help.sortOrder': 'Display order from 0 to 100. Smaller numbers appear first',
    'product.unit.validation.sortOrderRange': 'Sort order must be from 0 to 100',
    'product.unit.preview.title': 'Preview',
    'product.unit.preview.description':
      'This unit will appear in the product list using the order you configured.',
    'product.unit.deleteConfirm': 'Are you sure you want to delete unit {name}?',
    'product.unit.errors.saveFailed': 'Unable to save unit. Please try again.',
  },
}
